/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.29",
    versionName: "0.2.0-nightly.2026.3.29",
    versionChannel: "nightly",
    buildDate: "2026-03-29T00:12:57.734Z",
    commitHash: "a13d02e40a120228bf663161ba6c21d2a7e9b87d",
};
